var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showModal
    ? _c(
        "Modal",
        {
          staticClass: "join-classroom-modal",
          on: { close: _vm.handleCloseJoinClassModal }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn-close",
              on: { click: _vm.handleCloseJoinClassModal }
            },
            [
              _c("span", {
                directives: [
                  {
                    name: "track",
                    rawName: "v-track:click",
                    value: {
                      axId: "closed_schools_classroom_invitation",
                      axType: "button",
                      axExtra: {
                        classroom_id: _vm.classroomInviteInfo.classroom.id
                      }
                    },
                    expression:
                      "{\n        axId: 'closed_schools_classroom_invitation',\n        axType: 'button',\n        axExtra: {\n          classroom_id: classroomInviteInfo.classroom.id,\n        },\n      }",
                    arg: "click"
                  }
                ],
                staticClass: "b-sprite-global-close-black"
              })
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "b-sprite-homepage-jumpingmanorbit" }),
          _vm._v(" "),
          _c("h2", [_vm._v("Welcome to Brilliant!")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n    Your teacher, " +
                _vm._s(_vm.classroomInviteInfo.classroom.teacher_name) +
                ", has invited you to join\n    " +
                _vm._s(_vm.classroomInviteInfo.classroom.name) +
                ".\n  "
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "track",
                  rawName: "v-track:click",
                  value: {
                    axId: "clicked_schools_accept_classroom_invitation",
                    axType: "button",
                    axExtra: {
                      classroom_id: _vm.classroomInviteInfo.classroom.id
                    }
                  },
                  expression:
                    "{\n      axId: 'clicked_schools_accept_classroom_invitation',\n      axType: 'button',\n      axExtra: {\n        classroom_id: classroomInviteInfo.classroom.id,\n      },\n    }",
                  arg: "click"
                }
              ],
              staticClass: "btn btn-accent",
              on: { click: _vm.joinClassroom }
            },
            [_c("span", [_vm._v("Let's go!")])]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }